import getConst from "api/common/getConst";

export function clearAllCaches(withReload: boolean) {
    caches
        .keys()
        .then(function (names) {
            for (const name of names) caches.delete(name);
        })
        .finally(() => {
            if (withReload) {
                window.location.reload();
            }
        });
}

export function clearCurrentUserDataCache() {
    if (isCacheEnabled()) {
        caches.has("currentUserData").then((has) => {
            if (has) {
                caches.delete("currentUserData");
            }
        });
    }
}

export function isCacheEnabled() {
    return getConst("env-type") !== "development";
}
